import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import { EmptyBlock } from './EmptyBlock';
import { PatientPanelHeader } from './PatientPanelHeader';

import styles from './PatientDiagnosesPanel.module.scss';

export interface CaseDiagnosesInfo {
  caseTitle: string;
  diagnoses: string[];
}

export interface PatientDiagnosesProps {
  patientDiagnoses: CaseDiagnosesInfo[];
}

export const PatientDiagnoses: React.FC<PatientDiagnosesProps> = (props) => {
  const { patientDiagnoses } = props;
  const i18n = useScopedTranslation('patients.overview.diagnoses');

  if (patientDiagnoses.length === 0) {
    return (
      <div className={styles.emptyBlockContainer}>
        <EmptyBlock title={i18n.t('title')} text={i18n.t('empty')} />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <PatientPanelHeader title={i18n.t('title')} />
      {patientDiagnoses.map((item) => {
        return (
          <div key={`${item.caseTitle}`}>
            <div className={styles.title}>{item.caseTitle}</div>
            {item.diagnoses.map((diagnosis) => {
              return (
                <div key={`${diagnosis}`} className={styles.item}>
                  {diagnosis}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
